function closeImageGalleryLightbox(lightbox) {
  lightbox.hidden = true;
  var img = lightbox.querySelector('.image-gallery-lightbox__img');
  img.src = '';
  img.alt = '';
  if (window.P3Glass) window.P3Glass.close();
}

// Move the viewers to <body> so no transformed/animated ancestor section
// can confine their fixed, full-screen positioning.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.image-gallery-lightbox').forEach(function (lightbox) {
    document.body.appendChild(lightbox);
  });
});

document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-gallery-open]');
  if (opener) {
    var lightbox = document.getElementById(opener.dataset.galleryTarget);
    if (!lightbox) return;
    var img = lightbox.querySelector('.image-gallery-lightbox__img');
    img.src = opener.dataset.fullSrc;
    img.alt = opener.dataset.fullAlt || '';
    lightbox.hidden = false;
    if (window.P3Glass) window.P3Glass.open();
    return;
  }

  var closeButton = event.target.closest('.image-gallery-lightbox__close');
  if (closeButton) {
    closeImageGalleryLightbox(closeButton.closest('.image-gallery-lightbox'));
    return;
  }

  if (event.target.classList.contains('image-gallery-lightbox')) {
    closeImageGalleryLightbox(event.target);
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.image-gallery-lightbox:not([hidden])').forEach(closeImageGalleryLightbox);
});
